
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from "@angular/router";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';
import { SalesFilter } from '../../models/report/sale.model';

@Injectable()
export class ReportService {

  constructor(private http: Http, private cookieService: CookieService) { }
  private service = "api/Report";
  SearchHistoryReport(toDate: string, fromDate: string, PageNumber: number, PageSize: number) {
    return this.http.get(`${this.service}/SearchHistoryReport?toDate=` + toDate + `&fromDate=` + fromDate + '&PageNumber=' + PageNumber + '&PageSize=' + PageSize, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  SaleReportPreBind() {
    return this.http.get(`${this.service}/SaleReportPreBind`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  SaleReportFetch(saleFilter: SalesFilter) {
    return this.http.post(`${this.service}/SaleReportFetch?filter=`, saleFilter, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }



  ShipmentReportPreBind() {
    return this.http.get(`${this.service}/ShipmentReportPreBind`, {

      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  ShipmentReportFetch(saleFilter: SalesFilter) {
    return this.http.post(`${this.service}/ShipmentReportFetch?filter=`, saleFilter, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getRptVendors(StatusId: any, fromDate: any, dateTo: any) {
    return this.http.get(`${this.service}/GetReportVendor?statusId=` + StatusId + `&fromDate=` + fromDate + `&dateTo=` + dateTo, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getRptCustomer(fromDate: any, dateTo: any) {
    return this.http.get(`${this.service}/GetReportCustomer?fromDate=` + fromDate + `&dateTo=` + dateTo, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  exportRptCustomer(fromDate: any, dateTo: any) {
    return this.http.get(`${this.service}/ExportReportCustomer?fromDate=` + fromDate + `&dateTo=` + dateTo, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  getRptCustomerOrders(fromDate: any, dateTo: any) {
    return this.http.get(`${this.service}/GetReportCustomerOrders?fromDate=` + fromDate + `&dateTo=` + dateTo, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {

    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/report/report.service.ts